import React from 'react';
import { Copy } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const CopyClaimDialog = ({ open, onOpenChange, newServiceDate, setNewServiceDate, copying, onCopy }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Manrope' }}>Copy Claim (Claim Recycle™)</DialogTitle>
        <DialogDescription>
          Create a new claim with the same details. Just update the service date.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="new_service_date">New Service Date *</Label>
          <Input
            id="new_service_date"
            type="date"
            value={newServiceDate}
            onChange={(e) => setNewServiceDate(e.target.value)}
            data-testid="copy-claim-date"
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={onCopy}
          className="bg-indigo-900 hover:bg-indigo-800"
          disabled={copying}
          data-testid="copy-claim-submit-btn"
        >
          {copying ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <Copy size={16} className="mr-2" />
              Copy Claim
            </>
          )}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CopyClaimDialog;
